import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CachedIcon from "@mui/icons-material/Cached";
import SearchIcon from "@mui/icons-material/Search";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import ClipLoader from "react-spinners/ClipLoader";
import { Modal } from "react-responsive-modal";
import Select from "react-select";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationModal from "../../../components/Staff/Modals/ConfirmationModal";
import Cookies from "js-cookie";
import { useAuthContext } from "../../../Context/AuthContext";
import {
  HeaderSkeleton,
  PaginationSkeleton,
  TableSkeleton,
} from "../Skelton/Skelton";

const DepartmentDetail = () => {
  const { flowChangerToken } = useAuthContext();
  const [open10, setOpen10] = useState(false);
  const onOpenModal10 = () => setOpen10(true);
  const onCloseModal10 = () => setOpen10(false);
  const {
    baseUrl,
    setDepId,
    setName,
    openToast,
    departments,
    loadingDepartment,
    fetchDepartments,
    setDepartments,
  } = useGlobalContext();
  const [exportFormat, setExportFormat] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [rowsToShow, setRowsToShow] = useState(25);
  const [filteredData, setFilteredData] = useState(departments);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDepartmentName, setSearchDepartmentName] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [massDelete, setMassDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const recordsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const result = await fetchDepartments(currentPage);
      setDepartments(result.data);
      setTotalPages(result?.totalPages);
      setTotalRecords(result.totalRecords);
      setIsLoading(false);
    };
    fetchData();
  }, [currentPage]); // Re-fetch data when currentPage changes

  // 🔹 Handle Next Page Click
  const handleNext = () => {
    console.log("onClick")
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  // 🔹 Handle Previous Page Click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };


  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchDepartmentName(value);

    if (value.trim() === "") {
      fetchDepartments();
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
        `${baseUrl}department/search?department_name=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setDepartments(data || []);
      } else {
        openToast(data.message, "error");
      }
    } catch (error) {
      console.error("Error searching roles:", error);
    } finally {
      setIsSearching(false);
    }
  };

  // Handle select change for rows to show
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV();
    else if (exportFormat === "PDF") exportPDF();
    else if (exportFormat === "Print") printDepartments();
  };

  const exportCSV = () => {
    const csvData = departments
      .map((dep) => `${dep.department_name}`)
      .join("\n");
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "departments.csv");
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Department List", 20, 10);
    departments.forEach((dep, index) => {
      doc.text(`${index + 1}. ${dep.department_name}`, 10, 20 + index * 10);
    });
    doc.save("departments.pdf");
  };

  const printDepartments = () => {
    const printContent = departments
      .map((dep) => `${dep.department_name}`)
      .join("\n");
    const newWindow = window.open();
    newWindow.document.write(`<pre>${printContent}</pre>`);
    newWindow.document.close();
    newWindow.print();
  };

  const deleteDepartments = async (id) => {
    try {
      setIsLoading(true);
      const result = await fetch(`${baseUrl}department/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.ok) {
        openToast("Department Deleted", "success");
        fetchDepartments();
      } else {
        openToast(result.message);
      }
    } catch (error) {
      console.error("Error deleting department:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // handle search department
  useEffect(() => {
    if (!departments) {
      fetchDepartments();
    }
  }, []);

  const deleteDepartmentsBulk = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${baseUrl}department/bulk`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          departmentIds: selectedDepartments.map(({ value }) => value),
        }),
      });

      if (response.ok) {
        openToast("Departments deleted successfully");
        onCloseModal();
        fetchDepartments();
      }
    } catch (error) {
      console.error("Failed to delete departments:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [open, setOpen] = useState(false);

  const onOpenModal = () => {
    setSelectedDepartments([]); // Clear selections when opening
    setOpen(true);
  };
  const onCloseModal = () => setOpen(false);

  const departmentOptions = departments?.map((dep) => ({
    value: dep.id,
    label: dep.department_name,
  }));

  // Handle selection of departments
  const handleSelectChangebulk = (selectedOptions) => {
    setSelectedDepartments(selectedOptions || []);
  };

  // Handle Mass Delete Toggle
  const handleMassDelete = () => {
    if (!massDelete) {
      setSelectedDepartments(departmentOptions); // Select all departments
    } else {
      setSelectedDepartments([]); // Deselect all
    }
    setMassDelete(!massDelete);
  };

  const [allStaff, setAllStaff] = useState();

  const [taskStatus, setTaskStatus] = useState({
    name: "",
    color: "#000000",
    order: "",
    isHiddenFor: [],
    canBeChangedTo: [],
  });

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  };

  if (loadingDepartment || !departments) {
    return (
      <div className="bg-white mt-[20px] px-4 py-6 w-full staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }


  return (
    <div className="bg-white px-4 py-6 w-full">
      <Link to="/adddepartment" className="allcrm-btn">
        {" "}
        <AddIcon className="addicon-all" /> New Department
      </Link>

      <div className="table-section bg-white shadow-cs mt-5 p-[20px] rounded-lg">
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 mb-3">
          <div className="flex sm:flex-row flex-col flex-wrap items-center gap-2 w-full">
            <select
              onChange={handleSelectChange}
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-md focus:outline-none w-full sm:w-[60px] text-[14px]"
            >
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="120">120</option>
            </select>
            <select
              onChange={(e) => setExportFormat(e.target.value)}
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-md focus:outline-none w-full sm:w-[67px] text-[14px]"
            >
              <option value="CSV">CSV</option>
              <option value="PDF">PDF</option>
              <option value="Print">Print</option>
            </select>

            <button
              onClick={handleExport}
              className="bg-[#27004a] p-[7px] rounded-md w-full sm:w-[83px] text-[14px] text-white cursor-pointer"
            >
              Export File
            </button>
            <button
              className="shadow-sm p-[7px] border border-[#e5e7eb] rounded-lg w-full sm:w-[123px] text-[14px]"
              onClick={onOpenModal}
            >
              Bulk Action <CachedIcon className="newsidebar-icon" />{" "}
            </button>
          </div>
          <div className="relative flex flex-wrap justify-end items-center gap-2 w-full">
            <input
              type="text"
              placeholder="Search"
              value={searchDepartmentName}
              onChange={handleSearch}
              className="p-[10px] pr-7 border border-1 rounded-3xl focus:outline-none w-[100%] md:w-[200px] h-[38px] text-[#000] text-[15px] ]"
            />
            <SearchIcon className="right-[10px] absolute search-icon font-thin text-[#000] text-[#dddddd; ]" />{" "}
          </div>
        </div>
        <div className="bg-white shadow-cs rounded-lg w-full overflow-x-auto">
          <table class="p-[10px] w-[100%] table-auto">
            <thead className="bg-[#ffff]">
              <tr>
                <th className="p-4 border-[#dbdbdb] border-b font-medium text-sm text-center roll-name">
                  Name
                </th>
                <th className="p-4 border-[#dbdbdb] border-b font-medium text-sm text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loadingDepartment && !departments && (
                <tr className="h-[100px]">
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-gray-600 text-xl text-center"
                  >
                    <ClipLoader color="#27004a" size={50} />
                  </td>
                </tr>
              )}

              {!isSearching && departments?.length > 0 ? (
                departments?.map((dep, index) => (
                  <tr key={dep.id} className="pb-2 border-[#dbdbdb] border-b">
                    <td className="pt-4 pb-3 pl-3 border-[#dbdbdb] border-r">
                      <Link to="/" className="text-[#27004a] text-[14px]">
                        {dep.department_name}
                      </Link>
                    </td>
                    <td className="flex justify-center gap-2 pt-4">
                      <Link
                        to="/editdepartment"
                        onClick={() => {
                          setDepId(dep.id);
                          setName(dep);
                        }}
                      >
                        <BorderColorIcon className="font-light text-[#27004a] text-[10px]] cursor-pointer" />
                      </Link>
                      {/* <button
                        onClick={() =>  {
                          // deleteDepartments(dep.id);

                          onOpenModal10();
                        }}
                      >
                        <DeleteIcon className="text-red-500 cursor-pointer" />
                      </button> */}

                      <button onClick={() => deleteDepartments(dep.id)}>
                        <DeleteIcon className="text-red-500 cursor-pointer" />
                      </button>
                      {open10 && (
                        <ConfirmationModal
                          setClose={onCloseModal10}
                          id={dep.id}
                          isLoading={isLoading}
                          callback={deleteDepartments}
                        />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="h-[100px]">
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-gray-600 text-xl text-center"
                  >
                    No Department Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-4 w-full">
          {isLoading ? (
            <PaginationSkeleton />
          ) : (
            <>
              <p className="text-gray-500 text-sm">
                Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                {Math.min(currentPage * recordsPerPage, totalRecords)} of {totalRecords} entries
              </p>
              <div className="flex gap-2 p-0 border rounded-md pagination">
                <button
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                  className={`px-3 py-2 text-xs ${currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""}`}
                >
                  Previous
                </button>
                <span className="flex items-center bg-purple-900 px-3 text-white text-xs">{currentPage}</span>
                <button
                  onClick={handleNext}
                  disabled={currentPage >= totalPages}
                  className={`px-3 py-2 text-xs ${currentPage >= totalPages ? "opacity-40 cursor-not-allowed" : ""}`}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      {/* Bulk action modal */}
      <Modal open={open} onClose={onCloseModal} center>
        <div className="pb-[20px] border-[#dbdbdb] border-b">
          <h2>Bulk Actions</h2>
        </div>
        {/* Mass Delete Checkbox */}
        <div className="flex items-center gap-2 mt-4">
          <input
            type="checkbox"
            checked={massDelete}
            onChange={handleMassDelete}
          />
          <p className="text-[14px]">Mass Delete</p>
        </div>
        <div className="w-[100%]">
          {/* Multi-Select Dropdown */}
          <Select
            isMulti
            options={departmentOptions}
            value={selectedDepartments}
            onChange={handleSelectChangebulk}
            className="mt-2"
          />
        </div>

        {selectedDepartments?.length == 0 ? (
          <p className="mt-[10px] text-[14px] text-[red]">
            if you do not select any groups assigned to the selected customers
            will be removed.
          </p>
        ) : (
          ""
        )}

        <div className="flex justify-end gap-[10px] mt-[24px] pr-[10px] pb-3">
          {/* <button
            onClick={(e) => deleteDepartmentsBulk()}
            disabled={isLoading}
            className="second-btn"
          >
            {isLoading ? "Deleting..." : "Confirm Delete"}
          </button> */}

          {/* <button
            className="second-btn"
            onClick={deleteDepartmentsBulk}
            disabled={isLoading}
          >
            {isLoading ? "Deleting..." : "Confirm Delete"}
          </button> */}

          <button
            className={` ${isLoading == true ? "second-btn-disabled" : "second-btn"
              }`}
            onClick={deleteDepartmentsBulk}
          >
            Confirm
          </button>
        </div>
      </Modal>
      {/* Bulk action modal end */}
    </div>
  );
};

export default DepartmentDetail;
  